import { render, staticRenderFns } from "./Leveringsproducten.vue?vue&type=template&id=f916ad8a&"
import script from "./Leveringsproducten.vue?vue&type=script&lang=js&"
export * from "./Leveringsproducten.vue?vue&type=script&lang=js&"
import style0 from "./Leveringsproducten.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports